import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/decisionMakerResponse/details/pageContext';

export function DecisionMakerResponseErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for DecisionMakerResponse page (error: ${error})`);
}
